import { render } from "./headerDesktop.vue?vue&type=template&id=68016471&scoped=true"
import script from "./headerDesktop.vue?vue&type=script&lang=js"
export * from "./headerDesktop.vue?vue&type=script&lang=js"

import "./headerDesktop.vue?vue&type=style&index=0&id=68016471&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68016471"]])

export default __exports__